import React from 'react';

const CatalogueContext = React.createContext();

export const CatalogueContextProvider = CatalogueContext.Provider;

export default CatalogueContext;
